import { render, staticRenderFns } from "./ProductSelector.vue?vue&type=template&id=125e2329&"
import script from "./ProductSelector.ts?vue&type=script&lang=js&"
export * from "./ProductSelector.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports